import React from 'react';
import {Field} from 'formik';
import {TextField} from 'formik-mui';
import {Card} from '@mui/material';

export default function EntryOneEdit({code}) {
  return (
    <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 10}}>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Accession No.'}
             name={`accession_no`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Ownership'}
             name={`catalogue.ownership`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Classification'}
             name={`catalogue.classification`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Object Type'}
             name={`catalogue.object_type`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Sub Group'}
             name={`catalogue.sub_group`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Materials'}
             name={`catalogue.material`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
    </Card>
  );
}